let currentAudio: HTMLAudioElement | null = null;

export const playSoundEffect = (
  soundFile: string,
  enabled: boolean = true,
  volume: number = 0.3
) => {
  if (!enabled) return;

  try {
    // Stop any currently playing sound
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }

    const audio = new Audio(`/sounds/${soundFile}`);
    audio.volume = volume;
    currentAudio = audio;

    audio.play().catch(() => {
      currentAudio = null;
    });

    audio.onended = () => {
      if (currentAudio === audio) {
        currentAudio = null;
      }
    };
  } catch {
    currentAudio = null;
  }
};

export const SOUNDS = {
  SESSION_START: 'session-start.mp3',
  SESSION_COMPLETE: 'session-complete.mp3',
  BADGE_UNLOCK: 'badge-unlock.mp3',
  BREAK_COMPLETE: 'break-completion.mp3',
} as const;
